import { render, staticRenderFns } from "./perimetroCefalicoNinos.vue?vue&type=template&id=01347192&scoped=true&"
import script from "./perimetroCefalicoNinos.vue?vue&type=script&lang=js&"
export * from "./perimetroCefalicoNinos.vue?vue&type=script&lang=js&"
import style0 from "./perimetroCefalicoNinos.vue?vue&type=style&index=0&id=01347192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01347192",
  null
  
)

export default component.exports